import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Division } from 'src/app/shared/models/common.model';
import { STPAgency } from '../../models/stp_agency.model';
import { STPAppStatus } from '../../models/stp_app_status.model';
import { STPAppType } from '../../models/stp_app_type.model';
import { STPLocation } from '../../models/stp_location.model';
import { STPMinistry } from '../../models/stp_ministry.model';
import { STPOwnershipType } from '../../models/stp_ownership_type.model';
import { STPOwnerType } from '../../models/stp_owner_type.model';
import { STPType } from '../../models/stp_type.model';
import { SYSCountry } from '../../models/sys_country.model';
import { StpTabComponent } from '../stp-tab/stp-tab.component';
import { District, Upazila } from './../../../../shared/models/common.model';
import { STPMain } from './../../models/stp_main.model';
import { StpRegistrationStorageService } from './../../services/stp-registration-storage.service';
import { RequestData } from '../../models/stp_onlinePayment.model';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { StpRegistrationService } from '../../services/stp-registration.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-basic-profile',
  templateUrl: './basic-profile.component.html',
  styleUrls: ['./basic-profile.component.scss'],
})
export class BasicProfileComponent implements OnInit {
  constructor(
    private tab: StpTabComponent,
    private fb: FormBuilder,
    private msg: NzMessageService,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationService: StpRegistrationService,
    private notification: NzNotificationService,
    private route: ActivatedRoute
  ) {
    this.stpRegistrationStorageService.readStpType().subscribe({
      next: (res) => {
        this.stptypes = res;
      },
    });
    this.stpRegistrationStorageService.readStpUserName().subscribe({
      next: (res) => {
        this.stpName = res;
      },
    });
    // this.stpRegistrationStorageService.readStpOwnerType().subscribe({
    //   next: (res) => {
    //     this.stpOwnerTypes = res;
    //   },
    // });
    this.stpRegistrationStorageService.readStpOwnerShipType().subscribe({
      next: (res) => {
        this.stpOwnershipTypes = res;
      },
    });
    this.stpRegistrationStorageService.readStpLocations().subscribe({
      next: (res) => {
        this.stpLocations = res;
      },
    });

    this.stpRegistrationStorageService.readStpAppStatuses().subscribe({
      next: (res) => {
        this.stpAppStatuses = res;
      },
    });
    this.stpRegistrationStorageService.readStpAppTypes().subscribe({
      next: (res) => {
        this.stpAppTypes = res;
      },
    });
    this.stpIsCommittee = true;
  }

  // Help to get all photos controls as form array.
  get photos(): FormArray {
    return this.basicProfileForm.get('photos') as FormArray;
  }
  startValue: Date | null = null;
  endValue: Date | null = null;
  @ViewChild('endDatePicker') endDatePicker!: NzDatePickerComponent;

  requestData: RequestData = new RequestData();
  userInfo: any;
  stpMainId: number;
  basicProfileForm: FormGroup;
  isEditMode!: boolean;
  stpMain!: STPMain;
  stptypes: STPType[] = [];
  stpOwnerTypes: STPOwnerType[] = [];
  stpOwnershipTypes: STPOwnershipType[] = [];
  stpMinistries: STPMinistry[] = [];
  stpAgencies: STPAgency[] = [];
  stpLocations: STPLocation[] = [];
  // sysPostOffices: SYSPostOffice[] = [];
  sysCountries: SYSCountry[] = [];

  divisions: Division[] = [];
  districts: District[] = [];
  upazilas: Upazila[] = [];

  stpAppStatuses: STPAppStatus[] = [];
  stpAppTypes: STPAppType[] = [];
  stpName = '';
  stpIsCommittee: boolean;
  isExist = false;
  // location fixed once the application id (with its district code) exists
  isLocationLocked = false;
  // sent back for correction: like a renewal, the STP name and the location / address can't change
  isCorrectionLocked = false;
  contactNo: string;
  contactNumber: string;
  today = new Date();
  timeDefaultValue = setHours(new Date(), 0);

  disabledStartDate = (startValue: Date): boolean => {
    if (!startValue || !this.endValue) {
      return false;
    }
    return startValue.getTime() > this.endValue.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    if (!endValue || !this.startValue) {
      return false;
    }
    return endValue.getTime() < this.startValue.getTime();
  };

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open();
    }
  }

  disabledDate = (current: Date): boolean =>
    // Can select Years before today and today
    differenceInCalendarDays(current, this.today) > 0;

  // tslint:disable-next-line: typedef
  ngOnInit() {
    this.basicProfileForm = this.fb.group({
      // photos: this.fb.array([]),

      //#region Basic Profile
      stpName: ['', Validators.required],
      stpNameBangla: ['', [Validators.required, Validators.pattern(/^[\u0980-\u09FF\s,().":{}_\-\/;']*$/)]],
      stpTypeId: ['', Validators.required],
      // stpOwnerTypeId: ['', Validators.required],
      stpOwnershipTypeId: ['', Validators.required],
      stpMinistryId: ['', Validators.required],
      stpAgencyId: ['', Validators.required],
      establishYear: ['', Validators.required],
      stpLocationId: ['', Validators.required],

      //#endregion Basic Profile

      //#region Address of the organization

      stpCountryId: ['', Validators.required],
      // stpPostOfficeId: ['', Validators.required],
      postOffice: ['', Validators.required],
      address: ['', Validators.required],
      contactNumberPrefixForContactNo: ['+880'],
      contactNumberPrefixForContactNumber: ['+880'],
      contactNo: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern(/^1[3-9][0-9]{8}$/),
        ],
      ],
      email: ['', [Validators.email, Validators.required]],
      stpDivisionId: ['', Validators.required],
      stpDistrictId: ['', Validators.required],
      stpUpazillaId: ['', Validators.required],

      // don't find  (Website address) property from ERD

      //#endregion Address of the organization

      //#region Contact Person

      contactName: ['', Validators.required],
      contactDesignation: ['', Validators.required],
      contactNumber: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
          Validators.pattern(/^1[3-9][0-9]{8}$/),
        ],
      ],
      contactEmail: ['', [Validators.email, Validators.required]],

      //#endregion Contact Person

      //#region  commitee

      isCommittee: ['', Validators.required],
      totalMember: ['', [Validators.required, Validators.min(0)]],
      totalFemaleMember: ['', [Validators.required, Validators.min(0)]],
      approvalDateCommittee: ['', Validators.required],
      expirationDateCommittee: ['', Validators.required],
      md_member_file: [''],
      // don't use my html upload tag
      //#endregion commitee

      //#region application details
      // stpApplicationStatusId: ['', Validators.required],
      // stpAppTypeId: ['', Validators.required],
      // registrationNo: ['', Validators.required],
      // approvalDate: ['', Validators.required],
      // applicationDate: ['', Validators.required],
      // stpApplicationStatus: [''],

      //#endregion application details
    });
    this.basicProfileForm.get('stpMinistryId')?.disable();
    this.basicProfileForm.get('stpAgencyId')?.disable();
    // this.basicProfileForm.get('stpName')?.disable();
    this.basicProfileForm.get('stpDivisionId')?.disable();
    this.basicProfileForm.get('stpDistrictId')?.disable();
    this.basicProfileForm.get('stpUpazillaId')?.disable();
    // this.basicProfileForm.get('stpPostOfficeId')?.disable();
    this.basicProfileForm.get('stpCountryId')?.disable();
    this.basicProfileForm.get('totalMember')?.disable();
    this.basicProfileForm.get('totalFemaleMember')?.disable();
    this.basicProfileForm.get('approvalDateCommittee')?.disable();
    this.basicProfileForm.get('expirationDateCommittee')?.disable();

    this.requestData.id = this.route.snapshot.params.userId;
    if(!this.requestData.id){
      this.userId();
    }
    this.onUserFullInformationRequest();
  }

  submitForm(): void {
    for (const key of Object.keys(this.basicProfileForm.controls)) {
      this.basicProfileForm.controls[key].markAsDirty();
      this.basicProfileForm.controls[key].updateValueAndValidity();
    }
    // this.isExist = true;
    this.stpMain = this.basicProfileForm.value;
    this.stpMain.contactNo =
      this.basicProfileForm.get('contactNumberPrefixForContactNo')?.value +
      this.stpMain.contactNo;
    this.stpMain.contactNumber =
      this.basicProfileForm.get('contactNumberPrefixForContactNumber')?.value +
      this.stpMain.contactNumber;
    if (!this.isExist) {
      this.stpRegistrationStorageService
        .createBasicProfile(this.stpMain)
        .subscribe({
          next: (response) => {
            this.notification.success(
              'Success!',
              'Basic Profile create successfully'
            );
            // this.resetForm();
            this.userId();
            this.stpRegistrationService.isStpMainAlreadyCreated = true;
            this.onUserFullInformationRequest();
          },
          error: (error) => {
            // this.isExist = false;
            this.notification.error(
              'Failed',
              'Please! provide valid information'
            );
          },
        });
    } else {
      this.stpRegistrationStorageService
        .updateBasicProfile(this.stpMain)
        .subscribe({
          next: (response) => {
            this.notification.success(
              'Success!',
              'Basic Profile update successfully'
            );
            // this.resetForm();
            this.userId();
            this.onUserFullInformationRequest();
          },
          error: (error) => {
            // this.isExist = false;
            this.notification.error(
              'Failed',
              'Please! provide valid information'
            );
          },
        });
    }

    // this.resetForm();
  }

  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }

  //#region upload from tarque vai

  // file upload and preview

  // We will create multiple form controls inside defined form controls photos.
  createItem(thisData: { [x: string]: any; file?: any; url?: any }): FormGroup {
    return this.fb.group(thisData);
  }

  // tslint:disable-next-line: typedef
  detectFiles(event?: any) {
    const files = event.target.files;
    if (files) {
      for (const file of files) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.photos.push(
            this.createItem({
              file,
              url: e.target.result, // Base64 string for preview image
            })
          );
        };
        reader.readAsDataURL(file);
      }
    }
  }

  // tslint:disable-next-line: typedef
  removePhoto(i: number) {
    this.photos.removeAt(i);
  }
  // tslint:disable-next-line: typedef
  removeAllPhoto() {
    this.photos.clear();
  }
  //#endregion upload from tarque vai

  resetForm(): void {
    this.basicProfileForm.reset();
    this.isEditMode = false;
    for (const key of Object.keys(this.basicProfileForm.controls)) {
      this.basicProfileForm.controls[key].markAsPristine();
      this.basicProfileForm.controls[key].updateValueAndValidity();
    }
  }

  setCountriesByLocationTypeId(): void {
    // the location chain never opens once it is locked (country, division, district, upazila stay as saved)
    if (this.isLocationLocked || this.isCorrectionLocked) {
      return;
    }
    const id = this.basicProfileForm.get('stpLocationId')?.value;
    if (id === 1 || id === 2) {
      this.basicProfileForm.get('stpCountryId')?.reset();
      this.basicProfileForm.get('stpCountryId')?.enable();
      this.stpRegistrationStorageService.readStpCountries().subscribe({
        next: (res) => {
          this.sysCountries = res;
        },
      });
    } else {
      this.basicProfileForm.get('stpCountryId')?.reset();
      this.basicProfileForm.get('stpCountryId')?.disable();
    }
  }

  setStpMinistriesByOwnerShipId(): void {
    const id = this.basicProfileForm.get('stpOwnershipTypeId')?.value;
    if (id === 1) {
      this.basicProfileForm.get('stpMinistryId')?.enable();
      this.stpRegistrationStorageService
        .readStpMinistriesByOwnerShipId(id)
        .subscribe({
          next: (res) => {
            this.stpMinistries = res;
          },
        });
      this.basicProfileForm.get('stpMinistryId')?.reset();
    } else if (id === 2) {
      this.basicProfileForm.get('stpMinistryId')?.enable();
      this.stpRegistrationStorageService
        .readStpMinistriesByOwnerShipId(id)
        .subscribe({
          next: (res) => {
            this.stpMinistries = res;
          },
        });
      this.basicProfileForm.get('stpMinistryId')?.reset();
    } else if (id === 3) {
      this.basicProfileForm.get('stpMinistryId')?.enable();
      this.stpRegistrationStorageService
        .readStpMinistriesByOwnerShipId(id)
        .subscribe({
          next: (res) => {
            this.stpMinistries = res;
          },
        });
      this.basicProfileForm.get('stpMinistryId')?.reset();
    } else if (id === 4) {
      this.basicProfileForm.get('stpMinistryId')?.enable();
      this.stpRegistrationStorageService
        .readStpMinistriesByOwnerShipId(id)
        .subscribe({
          next: (res) => {
            this.stpMinistries = res;
          },
        });
      this.basicProfileForm.get('stpMinistryId')?.reset();
    } else {
      this.basicProfileForm.get('stpMinistryId')?.reset();
      this.basicProfileForm.get('stpMinistryId')?.disable();
    }
  }

  // Loads the dropdown options of the saved values, so a disabled (locked) dropdown still shows its value.
  // Only the lists are loaded: nothing is enabled or reset.
  private loadOptionsOfSavedValues(data: any): void {
    if (data?.stpOwnershipType?.id) {
      this.stpRegistrationStorageService.readStpMinistriesByOwnerShipId(data.stpOwnershipType.id)
        .subscribe({ next: (res) => (this.stpMinistries = res) });
    }
    if (data?.stpMinistry?.id) {
      this.stpRegistrationStorageService.readStpAgencyByMinistryId(data.stpMinistry.id)
        .subscribe({ next: (res) => (this.stpAgencies = res) });
    }
    if (data?.sysCountry?.id) {
      this.stpRegistrationStorageService.readStpCountries()
        .subscribe({ next: (res) => (this.sysCountries = res) });
      this.stpRegistrationStorageService.readStpDivisionsBYCountryID(data.sysCountry.id)
        .subscribe({ next: (res) => (this.divisions = res) });
    }
    if (data?.sysDivision?.id) {
      this.stpRegistrationStorageService.readStpDistrictsByDivisionId(+data.sysDivision.id)
        .subscribe({ next: (res) => (this.districts = res) });
    }
    if (data?.sysDistrict?.id) {
      this.stpRegistrationStorageService.readStpUpazillasByDistrictId(+data.sysDistrict.id)
        .subscribe({ next: (res) => (this.upazilas = res) });
    }
  }

  setAgencyByMinId(): void {
    const id = this.basicProfileForm.get('stpMinistryId')?.value;
    if (id != null) {
      this.basicProfileForm.get('stpAgencyId')?.reset();
      this.basicProfileForm.get('stpAgencyId')?.enable();
      this.stpRegistrationStorageService
        .readStpAgencyByMinistryId(id)
        .subscribe({
          next: (res) => {
            this.stpAgencies = res;
          },
        });
    } else {
      this.basicProfileForm.get('stpAgencyId')?.reset();
      this.basicProfileForm.get('stpAgencyId')?.disable();
    }
  }

  setDivisionByCountryId(): void {
    if (this.isLocationLocked || this.isCorrectionLocked) {
      return;
    }
    const id = this.basicProfileForm.get('stpCountryId')?.value;
    if (id === 1) {
      this.basicProfileForm.get('stpDivisionId')?.reset();
      this.basicProfileForm.get('stpDivisionId')?.enable();
      this.stpRegistrationStorageService
        .readStpDivisionsBYCountryID(id)
        .subscribe({
          next: (res) => {
            this.divisions = res;
          },
        });
    } else {
      this.basicProfileForm.get('stpDivisionId')?.reset();
      this.basicProfileForm.get('stpDivisionId')?.disable();
    }
  }

  setDistrictInformation(): void {
    if (this.isLocationLocked || this.isCorrectionLocked) {
      return;
    }
    const id = this.basicProfileForm.get('stpDivisionId')?.value;
    if (id != null) {
      this.basicProfileForm.get('stpDistrictId')?.reset();
      this.basicProfileForm.get('stpDistrictId')?.enable();

      this.stpRegistrationStorageService
        .readStpDistrictsByDivisionId(+id)
        .subscribe({
          next: (res) => {
            this.districts = res;
          },
        });
    } else {
      this.basicProfileForm.get('stpDistrictId')?.reset();
      this.basicProfileForm.get('stpDistrictId')?.disable();
    }
  }

  setStpUpazillaInformation(): void {
    if (this.isLocationLocked || this.isCorrectionLocked) {
      return;
    }
    const id = this.basicProfileForm.get('stpDistrictId')?.value;
    if (id != null) {
      this.basicProfileForm.get('stpUpazillaId')?.reset();
      this.basicProfileForm.get('stpUpazillaId')?.enable();

      this.stpRegistrationStorageService
        .readStpUpazillasByDistrictId(+id)
        .subscribe({
          next: (res) => {
            this.upazilas = res;
          },
        });
    } else {
      this.basicProfileForm.get('stpUpazillaId')?.reset();
      this.basicProfileForm.get('stpUpazillaId')?.disable();
    }
  }

  // setStpPostOfficeInformation(): void {
  //   const id = this.basicProfileForm.get('stpUpazillaId')?.value;
  //   if (id != null) {
  //     this.basicProfileForm.get('stpPostOfficeId')?.reset();
  //     this.basicProfileForm.get('stpPostOfficeId')?.enable();

  //     this.stpRegistrationStorageService
  //       .readStpPostOfficesByUpazilaId(+id)
  //       .subscribe({
  //         next: (res) => {
  //           this.sysPostOffices = res;
  //         },
  //       });
  //   } else {
  //     this.basicProfileForm.get('stpPostOfficeId')?.reset();
  //     this.basicProfileForm.get('stpPostOfficeId')?.disable();
  //   }
  // }

  // tslint:disable-next-line: typedef
  setVisibilityOfCommittee() {
    const flag = Boolean(
      JSON.parse(this.basicProfileForm.get('isCommittee')?.value)
    );
    if (flag) {
      this.basicProfileForm.get('totalMember')?.reset();
      this.basicProfileForm.get('totalMember')?.enable();
      this.basicProfileForm.get('totalFemaleMember')?.reset();
      this.basicProfileForm.get('totalFemaleMember')?.enable();
      this.basicProfileForm.get('approvalDateCommittee')?.reset();
      this.basicProfileForm.get('approvalDateCommittee')?.enable();
      this.basicProfileForm.get('expirationDateCommittee')?.reset();
      this.basicProfileForm.get('expirationDateCommittee')?.enable();
      this.stpIsCommittee = true;
    } else {
      this.basicProfileForm.get('totalMember')?.reset();
      this.basicProfileForm.get('totalMember')?.disable();
      this.basicProfileForm.get('totalFemaleMember')?.reset();
      this.basicProfileForm.get('totalFemaleMember')?.disable();
      this.basicProfileForm.get('approvalDateCommittee')?.reset();
      this.basicProfileForm.get('approvalDateCommittee')?.disable();
      this.basicProfileForm.get('expirationDateCommittee')?.reset();
      this.basicProfileForm.get('expirationDateCommittee')?.disable();
      this.stpIsCommittee = false;
    }
  }

  // tslint:disable-next-line:typedef
  userId() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
  }

  // tslint:disable-next-line:typedef
  onUserFullInformationRequest() {
    this.stpRegistrationStorageService
      .stpMainIdByUserId(this.requestData)
      .subscribe({
        next: (res) => {
          if (res.data) {
            this.stpMainId = res.data;
            this.getStpApplicationById();
          }
        }
      });
  }

  // tslint:disable-next-line:typedef
  private getStpCommitteeById() {
    this.stpRegistrationStorageService
      .readStpApplicationsbyId(this.stpMainId)
      .subscribe((res) => {
        this.basicProfileForm.patchValue({
          totalMember: res.data.stpUserInfoDto.totalMember,
          totalFemaleMember: res.data.stpUserInfoDto.totalFemaleMember,
          approvalDateCommittee: new Date(res.data.stpUserInfoDto.approvalDate),
          expirationDateCommittee: new Date(res.data.stpUserInfoDto.expireDate),
        });
      });
  }

  // tslint:disable-next-line:typedef
  private getStpApplicationById() {
    // @ts-ignore
    this.stpRegistrationStorageService
      .readBasicProfileById(this.stpMainId)
      .subscribe((res) => {
        if (res.data) {

          this.stpRegistrationService.setStpMainInfo(res.data);
          this.isExist = true;
          // The application id carries the district code, so once it is generated the location can't be
          // changed (the chain under it - country, division, district, upazila - stays locked as well)
          this.isLocationLocked = !!res.data.applicationId;
          if (this.isLocationLocked) {
            ['stpLocationId', 'stpCountryId', 'stpDivisionId', 'stpDistrictId', 'stpUpazillaId']
              .forEach((name) => this.basicProfileForm.get(name)?.disable());
          }
          // Sent back for correction: like a renewal, the STP name and the location / Address of the
          // Organization can't change (the backend keeps them as submitted); the rest stays editable
          this.isCorrectionLocked = res.data.isTempRejected === true;
          if (this.isCorrectionLocked) {
            [
              'stpName', 'establishYear', 'stpLocationId', 'stpCountryId', 'stpDivisionId', 'stpDistrictId', 'stpUpazillaId',
              'postOffice', 'address',
            ].forEach((name) => this.basicProfileForm.get(name)?.disable());
          }
          this.stpRegistrationService.isStpMainAlreadyCreated = true;
          // this.notification.success(
          //   'Already Created!',
          //   'Basic Profile already created successfully'
          // );
          this.contactNo = res.data.contactNo;
          this.contactNumber = res.data.contactNumber;
          this.basicProfileForm.patchValue({
            stpName: res.data.stpName,
            stpNameBangla: res.data.stpNameBangla,
            stpTypeId: res.data.stpType.id,
            stpOwnershipTypeId: res.data.stpOwnershipType.id,
            stpMinistryId: res.data.stpMinistry.id,
            stpAgencyId: res.data.stpAgency.id,
            establishYear: res.data.establishYear,
            stpLocationId: res.data.stpLocation.id,

            stpCountryId: res.data.sysCountry.id,
            postOffice: res.data.postOffice,
            address: res.data.address,
            contactNo: this.contactNo.substring(4),
            email: res.data.email,
            stpDivisionId: res.data.sysDivision.id,
            stpDistrictId: res.data.sysDistrict.id,
            stpUpazillaId: res.data.sysUpazilla.id,

            contactName: res.data.contactName,
            contactDesignation: res.data.contactDesignation,
            contactNumber: this.contactNumber.substring(4),
            contactEmail: res.data.contactEmail,

            isCommittee: res.data.isCommittee,
            // totalMember: res.data.stpUserInfoDto.totalMember,
            // totalFemaleMember: res.data.stpUserInfoDto.totalFemaleMember,
            // // approvalDateCommittee: res.data.stpUserInfoDto.approvalDate,
            // approvalDateCommittee: res.data.stpUserInfoDto.approvalDate,
            // // expirationDateCommittee: res.data.stpUserInfoDto.expireDate,
            // expirationDateCommittee: res.data.stpUserInfoDto.expireDate,
            // applicationDate: res.data,
            // stpApplicationStatus: res.data,
            // dateOfCommencementPC: this.datepipe.transform(res.expCommencementDate, 'dd-MM-yyyy'),
            // dateOfCompletionPC: this.datepipe.transform(res.expCompletionDate, 'dd-MM-yyyy')
          });
          this.loadOptionsOfSavedValues(res.data);
          if (res.data.isCommittee) {
            this.stpIsCommittee = true;
            this.getStpCommitteeById();
            const flag = Boolean(
              JSON.parse(this.basicProfileForm.get('isCommittee')?.value)
            );
            if (flag) {
              this.basicProfileForm.get('totalMember')?.reset();
              this.basicProfileForm.get('totalMember')?.enable();
              this.basicProfileForm.get('totalFemaleMember')?.reset();
              this.basicProfileForm.get('totalFemaleMember')?.enable();
              this.basicProfileForm.get('approvalDateCommittee')?.reset();
              this.basicProfileForm.get('approvalDateCommittee')?.enable();
              this.basicProfileForm.get('expirationDateCommittee')?.reset();
              this.basicProfileForm.get('expirationDateCommittee')?.enable();
              this.stpIsCommittee = true;
            }
          } else {
            this.stpIsCommittee = false;
          }
        }
      });
  }

  nextPage(): void {
    this.tab.onclickButton();
  }
  previousPage(): void {
    this.tab.onclickButtonPrevious();
  }

  cancel(): void {
    this.msg.info('click cancel');
  }
}
